export const addUser = {
    fields:[{
        id:'name',
        Label:'First Name',
        type:'Text',
        contentType:'text',
        require:true
    },
    // {
    //     id:'lastName_user',
    //     Label:'Last Name',
    //     type:'Text',
    //     contentType:'text',
    //     require:true
    // },
    {
        id:'email',
        Label:'Email',
        type:'Text',
        contentType:'email',
        require:true
    },
    {
        id:'association',
        Label:'Association',
        type:'Text',
        contentType:'text',
        require:true
    },
    {
        id:'phoneno',
        Label:'Phone No',
        type:'Phone',
        contentType:'phone',
        require:true
    },
]
}